/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown>, year: NonNullable<unknown> }} Plan_Card_ExpInputs */

const en_plan_card_exp = /** @type {(inputs: Plan_Card_ExpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exp ${i?.month}/${i?.year}`)
};

const es_plan_card_exp = /** @type {(inputs: Plan_Card_ExpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vence ${i?.month}/${i?.year}`)
};

/**
* | output |
* | --- |
* | "Exp {month}/{year}" |
*
* @param {Plan_Card_ExpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_card_exp = /** @type {((inputs: Plan_Card_ExpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_ExpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_card_exp(inputs)
	return en_plan_card_exp(inputs)
});